module.exports = __webpack_public_path__ + "static/media/facebook.62ab4abc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/social/facebook.svg
// module id = 135
// module chunks = 0